module.exports = __webpack_public_path__ + "media/iconic/connections-3c6a55c4.svg";